import { DatePipe } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.css']
})
export class InvoicesComponent implements OnInit {

  constructor(private invoiceService:ServiceService,private route: ActivatedRoute, private router: Router) { }

  
  //------function for routing-------------------------

  InvoiceDetails(){
    this.router.navigateByUrl(('admin/invoice-detail'));  
  }
  
  //--------function which give name of selected item---------
  getValue = (item : string) =>{
     
    this.invoiceService.setInvoiceId(item)
    console.log("id=",item)
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  
  }
  
    output:any=[];

    baseUrl=this.invoiceService.ReturnBase();
    getUrl=this.baseUrl+'viewInvoices';
    searchEmployeeUrl=this.baseUrl+'viewEmployees?employee_name=';
    searchCustomerUrl=this.baseUrl+'viewCustomers?customer_name=';
    /*
    getUrl='http://192.241.151.66:5000/viewInvoices';
    empUrl='http://192.241.151.66:5000/viewEmployees';
    custUrl='http://192.241.151.66:5000/viewCustomers';
    searchEmployeeUrl='http://192.241.151.66:5000/viewEmployees?employee_name='
    searchCustomerUrl='http://192.241.151.66:5000/viewCustomers?customer_name='
    */
    count=0;
    searchEmployee:string='';
    searchCustomer:string='';
    employee:any=[];
    customers:any=[];
    isShownEmployee=false
    isShownCustomer=false
    
    employee_id=""
    customer_id=""
    ApplayFlag=0;
    salesValue=""
    loaderShown=false
    tableShown=true;

    admin_id=localStorage.getItem('admin_id');

    data={
      from_date:"",
      to_date:"",
      responsible_employee_id:"",
      company_id:""
    }
    data1={
      from_date:"",
      to_date:"",
      responsible_employee_id:""
    }
    data2={
      from_date:"",
      to_date:"",
      company_id:""
    }
    data3={
      from_date:"",
      to_date:""
    }
    data4={
      company_id:"",
      responsible_employee_id:"",
    }
    data5={
      responsible_employee_id:""
    }
    data6={
      company_id:""
    }
    data8={
      from_date:"",
      to_date:"",
      responsible_employee_id:"",
      company_id:"",
      emp_name:"",
      c_name:""

    }
    
    /*-------for getting id of selected employee ----
   onSelected(value:string): void {
    this.data. responsible_employee_id= value;
    console.log("eid=",value)
  }
   //-------for getting id of selected employee ----
   onSelectedCustomer(value:string): void {
    this.data.company_id= value;
    console.log("cid",value)
    
  }
    */
  //-------------function for search employee--------------------
SearchEmployee(){
  if(this.data8.emp_name!='')
  {
  this.isShownEmployee=true;
  }
  this.searchEmployee=this.data8.emp_name
  this.invoiceService.getData(this.searchEmployeeUrl+this.searchEmployee).subscribe((res)=>{
  this.employee=res.data
 
  })
}
//---------function for getting searched employee id---------------
getEmployeeId(value1:any,value2:any){
     
     this.isShownEmployee=false
     //this.searchEmployee=value2
     //this.employee_id=value1
     this.data8.emp_name=value2
     this,this.data8.responsible_employee_id=value1
     console.log("search result",this.employee_id)
}
//-------------function for search customer--------------------
SearchCustomer(){
  
  if(this.data8.c_name==''){
    this.loaderShown=false;
  }
  if(this.data8.c_name!='')
  {
  this.isShownCustomer=true;
  this.loaderShown=true;
 // this.tableShown=false;
  }
  this.searchCustomer=this.data8.c_name
  this.customers=[];
  
  this.invoiceService.getData(this.searchCustomerUrl+this.searchCustomer+'&employee_id='+this.admin_id).subscribe((res)=>{
  this.customers=res.data
  this.loaderShown=false;
  //this.tableShown=true;
  })
}
//---------function for getting searched customer id---------------
getCustomerId(value1:any,value2:any){
     
     this.isShownCustomer=false
    // this.searchCustomer=value2
     //this.customer_id=value1
     this.data8.c_name=value2
    this.data8.company_id=value1;
}

    //function for going to next page
      clicks_next(){
        this.count=this.count+1;
        /*=========================================================*/
     if(this.ApplayFlag==1&&this.data8.responsible_employee_id=="" && this.data8.company_id!="" && this.data8.from_date!=""&&this.data8.to_date!="")
      {
       
        this.invoiceService.postData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id,this.data2).subscribe((res)=>{
        this.output=res.data
        console.log("1")
         })
      }
  //------call api without customer id field-------
  else if(this.ApplayFlag==1 && this.data8.company_id=="" && this.data8.responsible_employee_id!="" && this.data8.from_date!=""&&this.data8.to_date!="")
       {
          this.invoiceService.postData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id,this.data1).subscribe((res)=>{
          this.output=res.data
          console.log("Array=",this.output)
          console.log("2")
          })
        }
  else if(this.ApplayFlag==1 && this.data8.company_id=="" && this.data8.responsible_employee_id=="" && this.data8.from_date!=""&&this.data8.to_date!="")
      {
        
        this.invoiceService.postData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id,this.data3).subscribe((res)=>{
        this.output=res.data
        console.log("3")
       })
      }
    else if(this.ApplayFlag==1 &&this.data8.company_id!="" && this.data8.responsible_employee_id!="" && this.data8.from_date==""&&this.data8.to_date=="")
      {
       
        this.invoiceService.postData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id,this.data4).subscribe((res)=>{
        this.output=res.data
        console.log("4")
        })

    }
    else if(this.ApplayFlag==1 && this.data8.company_id=="" && this.data8.responsible_employee_id!="" && this.data8.from_date==""&&this.data8.to_date=="")
    {
      
      this.invoiceService.postData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id,this.data5).subscribe((res)=>{
      this.output=res.data
      console.log("5")
      })

    }
    else if(this.ApplayFlag==1 && this.data8.company_id!="" && this.data8.responsible_employee_id=="" && this.data8.from_date==""&&this.data8.to_date=="")
    {
      
      this.invoiceService.postData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id,this.data6).subscribe((res)=>{
      this.output=res.data
      console.log("6")
      })

    }
    else if(this.ApplayFlag==1 && this.data8.company_id!="" && this.data8.responsible_employee_id!="" && this.data8.from_date!=""&&this.data8.to_date!="")
    {
      this.invoiceService.postData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id,this.data).subscribe((res)=>{
      this.output=res.data
      console.log("7")
      })

    }
        /*=============================================================*/
        
        
        else{
        //-------api get()calling for next page-------------
        this.invoiceService.getData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id).subscribe((res)=>{
        this.output=res.data
        })
      }
      }
      
      //function for going to previous page
      clicks_previous(){
        this.count=this.count-1;
        if(this.count<0)
        {
          this.count=0
        }
        
      /*======================================================================*/
      if(this.ApplayFlag==1&&this.data8.responsible_employee_id=="" && this.data8.company_id!="" && this.data8.from_date!=""&&this.data8.to_date!="")
      {
       
        this.invoiceService.postData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id,this.data2).subscribe((res)=>{
        this.output=res.data
        console.log("1")
         })
      }
      //------call api without customer id field-------
      else if(this.ApplayFlag==1 && this.data8.company_id=="" && this.data8.responsible_employee_id!="" && this.data8.from_date!=""&&this.data8.to_date!="")
       {
          this.invoiceService.postData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id,this.data1).subscribe((res)=>{
          this.output=res.data
          console.log("Array=",this.output)
          console.log("2")
          })
        }
     else if(this.ApplayFlag==1 && this.data8.company_id=="" && this.data8.responsible_employee_id=="" && this.data8.from_date!=""&&this.data8.to_date!="")
      {
        
        this.invoiceService.postData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id,this.data3).subscribe((res)=>{
        this.output=res.data
        console.log("3")
       })
      }
     else if(this.ApplayFlag==1 &&this.data8.company_id!="" && this.data8.responsible_employee_id!="" && this.data8.from_date==""&&this.data8.to_date=="")
      {
       
        this.invoiceService.postData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id,this.data4).subscribe((res)=>{
        this.output=res.data
        console.log("4")
        })

    }
    else if(this.ApplayFlag==1 && this.data8.company_id=="" && this.data8.responsible_employee_id!="" && this.data8.from_date==""&&this.data8.to_date=="")
    {
      
      this.invoiceService.postData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id,this.data5).subscribe((res)=>{
      this.output=res.data
      console.log("5")
      })

    }
    else if(this.ApplayFlag==1 && this.data8.company_id!="" && this.data8.responsible_employee_id=="" && this.data8.from_date==""&&this.data8.to_date=="")
    {
      
      this.invoiceService.postData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id,this.data6).subscribe((res)=>{
      this.output=res.data
      console.log("6")
      })

    }
    else if(this.ApplayFlag==1 && this.data8.company_id!="" && this.data8.responsible_employee_id!="" && this.data8.from_date!=""&&this.data8.to_date!="")
    {
      this.invoiceService.postData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id,this.data).subscribe((res)=>{
      this.output=res.data
      console.log("7")
      })

    }
      /*=======================================================================*/
        else{
        //-------api get()calling for previous page-------------
        this.invoiceService.getData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id).subscribe((res)=>{
        this.output=res.data
        })
      }
      }

  btnClick(){

    this.ApplayFlag=1;
//------------timer---------------------
/*
this.tableShown=false
 this.loaderShown=true
  setTimeout(() => {
    this.loaderShown=false;
    this.tableShown=true
  }, 800);
  */
//--------------------------------------
   
   if(this.data8.emp_name=="")
   {
    this.data8.responsible_employee_id=""
   }
   if(this.data8.c_name=="")
   {
    this.data8.company_id=""
   }
   console.log("Fdate",this.data8.from_date)
   console.log("Todate",this.data8.to_date)
   console.log("ename",this.data8.emp_name)
   console.log("eid=",this.data8.responsible_employee_id)
   console.log("cname=",this.data8.c_name)
   console.log("cid",this.data8.company_id)
  //-----call api without employee id field------
  this.count=0
  console.log("button click")
  this.loaderShown=true;
  this.tableShown=false;
  if(this.data8.responsible_employee_id=="" && this.data8.company_id!="" && this.data8.from_date!=""&&this.data8.to_date!="")
      {
        console.log("empty employee field");
        this.data2.from_date=this.data8.from_date
        this.data2.to_date=this.data8.to_date
        this.data2.company_id=this.data8.company_id
        this.invoiceService.postData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id,this.data2).subscribe((res)=>{
        this.output=res.data
        console.log("1")
        this.loaderShown=false;
        this.tableShown=true;
         })
      }
  //------call api without customer id field-------
  else if(this.data8.company_id=="" && this.data8.responsible_employee_id!="" && this.data8.from_date!=""&&this.data8.to_date!="")
       {
          this.data1.from_date=this.data8.from_date
          this.data1.to_date=this.data8.to_date
          this.data1.responsible_employee_id=this.data8.responsible_employee_id
          this.invoiceService.postData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id,this.data1).subscribe((res)=>{
          this.output=res.data
          console.log("Array=",this.output)
          console.log("2")
          this.loaderShown=false;
          this.tableShown=true;
          })
        }
  else if(this.data8.company_id=="" && this.data8.responsible_employee_id=="" && this.data8.from_date!=""&&this.data8.to_date!="")
      {
        this.data3.from_date=this.data8.from_date
        this.data3.to_date=this.data8.to_date
        console.log("From=",this.data3.from_date)
        console.log("to=",this.data3.to_date)
        this.invoiceService.postData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id,this.data3).subscribe((res)=>{
        this.output=res.data
        console.log("3")
        this.loaderShown=false;
        this.tableShown=true;
       })
      }
    else if(this.data8.company_id!="" && this.data8.responsible_employee_id!="" && this.data8.from_date==""&&this.data8.to_date=="")
      {
        this.data4.company_id=this.data8.company_id
        this.data4.responsible_employee_id=this.data8.responsible_employee_id
        this.invoiceService.postData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id,this.data4).subscribe((res)=>{
        this.output=res.data
        console.log("4")
        this.loaderShown=false;
        this.tableShown=true;
        })

    }
    else if(this.data8.company_id=="" && this.data8.responsible_employee_id!="" && this.data8.from_date==""&&this.data8.to_date=="")
    {
      this.data5.responsible_employee_id=this.data8.responsible_employee_id
      this.invoiceService.postData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id,this.data5).subscribe((res)=>{
      this.output=res.data
      console.log("5")
      this.loaderShown=false;
      this.tableShown=true;
      })

    }
    else if(this.data8.company_id!="" && this.data8.responsible_employee_id=="" && this.data8.from_date==""&&this.data8.to_date=="")
    {
      this.data6.company_id=this.data8.company_id
      this.invoiceService.postData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id,this.data6).subscribe((res)=>{
      this.output=res.data
      console.log("6")
      this.loaderShown=false;
      this.tableShown=true;
      })

    }
    else if(this.data8.company_id!="" && this.data8.responsible_employee_id!="" && this.data8.from_date!=""&&this.data8.to_date!="")
    {
      this.data.from_date=this.data8.from_date
      this.data.to_date=this.data8.to_date
      this.data.responsible_employee_id=this.data8.responsible_employee_id
      this.data.company_id=this.data8.company_id
      this.invoiceService.postData(this.getUrl+'?offset='+this.count+'&limit=20&user_id='+this.admin_id,this.data).subscribe((res)=>{
      this.output=res.data
      console.log("7")
      this.loaderShown=false;
      this.tableShown=true;
      })

    }
    else{

      this.invoiceService.getData(this.getUrl).subscribe((res)=>{
      this.output=res.data
      console.log("8")
      this.loaderShown=false;
      this.tableShown=true;
      })

    }

   }
   
  //-------date formating-------------
  
  today: Date = new Date();
  pipe = new DatePipe('en-US');
  todayWithPipe:any= null;
  DateFormat(value:any){

    //-------date formating----------------------
    this.todayWithPipe = this.pipe.transform(value, 'MMM d, y, h:mm:ss a');
    return this.todayWithPipe

  }
  ngOnInit(): void {
  this.tableShown = false;
  this.loaderShown = true;

  // Don't call any API initially - just show empty state or loading
  // You can either:
  
  // Option 1: Show empty table initially
  this.output = [];
  this.tableShown = true;
  this.loaderShown = false;
  
  // OR Option 2: Keep the loading state until user clicks Apply
  // (remove the above 3 lines if you want to keep loader until Apply is clicked)
}

}
